import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import '../../Dashboard/Dashboard.css'
import '../../Invoice/invoice.css'
import CustomTable from '@/product/components/molecules/CustomTable'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CartContext from '@/product/context/cart/cartContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import ReportContext from '@/product/context/report/reportContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import InvoiceView from '../../Invoice/view'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import PaymentManage from '../../Invoice/PaymentManage'
import RefundInvoice from '../../../custom/components/organisms/RefundInvoice'
import {
    getSummaryFields,
    handleRedirectInternal,
    mapData,
} from '@/product/common/components'
import { useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import AuthContext from '@/product/context/auth/authContext'
import AlertContext from '@/product/context/alert/alertContext'

const UserInvoices = (props) => {
    const reportContext = useContext(ReportContext)
    const invoiceContext = useContext(InvoiceContext)
    const cartContext = useContext(CartContext)
    const customCommonContext = useContext(CustomCommonContext)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)

    const [isLoading, setIsLoading] = useState(true)
    const { setAlert } = alertContext
    const { getAllExportDownload } = reportContext
    const { allAgencies } = customCommonContext
    const history = useHistory()

    const {
        all_invoices,
        getAllInvoices,
        changeProductStatus,
        responseStatus: responseStatusInvoice,
        clearResponse: clearResponseInvoice,
    } = invoiceContext
    const { responseStatus: responseStatusCart } = cartContext
    const { user } = authContext

    const [changeStatus, setChangeStatus] = useState(false)
    const [invoiceNotesStatus, setInvoiceNotesStatus] = useState(false)
    const [filteredAgencies, setFilteredAgencies] = useState([])

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const [manageCredits, setManageCredits] = useState({
        popup: false,
        status: 'new',
        data: null,
        id: 0,
        sid: 0,
    })

    const [manageRefund, setManageRefund] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenPopup = (popup, status, id, sid) => {
        if (popup) {
            setManage({ popup, status, id, sid })
        } else {
            setManage({ popup, status: status ? status : 'new', id: 0, sid: 0 })
        }
    }

    const toggleCreditsPopup = (popup, status, data) => {
        if (popup) {
            setManageCredits({ popup, status, data })
        } else {
            setManageCredits({ popup, status: 'new', data: null })
        }
    }

    const toggleRefundPopup = (popup, status, data) => {
        if (popup) {
            setManageRefund({ popup, status, data })
        } else {
            setManageRefund({ popup, status: 'new', data: null })
        }
    }

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const toggleInvoiceModal = () => {
        setInvoiceNotesStatus(!invoiceNotesStatus)
    }

    let action = 'all'
    let pay_status = ''

    const [tableBody, setTableBody] = useState([])

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_id: '',
            auction_id: '',
            notes: '',
        },
        validationSchema: Yup.object({
            notes: Yup.string().when('action', {
                is: 'cancel',
                then: Yup.string().required('Required!'),
            }),
        }),
        onSubmit: (values) => {
            if (
                values.action === 'paid' ||
                values.action === 'draft' ||
                values.action === 'cancel'
            ) {
                changeProductStatus(values)
            } else if (values.action === 'pay_received') {
                changeProductStatus(values)
            } else {
                assignAuctionLot(values)
            }
        },
    })

    const formikNotesSelection = useFormik({
        initialValues: {
            invoice_notes: '',
        },
        validationSchema: Yup.object({
            invoice_notes: Yup.string().required('Required'),
        }),
        onSubmit: (values) => {
            console.log(values, 'checkValues')
        },
    })

    useEffect(() => {
        if (all_invoices) {
            if (all_invoices.records.length) {
                let mapping = all_invoices.records.map((data) => {
                    if (
                        (data.paid && !data.partial && data.active == 1) ||
                        (data.paid && data.partial && data.active == 1)
                    ) {
                        data.invoice_status = 'Paid'
                    } else if (
                        !data.paid &&
                        !data.partial &&
                        (data.active == 0 || data.active == 1)
                    ) {
                        data.invoice_status = 'Unpaid'
                    } else if (!data.paid && data.partial && data.active == 0) {
                        data.invoice_status = 'Partially Paid'
                    } else {
                        data.invoice_status = 'Cancelled'
                    }
                    return data
                })
                setTableBody(mapping)
            } else {
                setTableBody([])
            }
            setTableBody(
                all_invoices.records.length ? all_invoices.records : []
            )
            setIsLoading(false)
        }
    }, [all_invoices])

    useEffect(() => {
        if (user?.emp_type && user.emp_type === 'agency') {
            if (allAgencies && allAgencies.length) {
                if (user && user.emp_agencies) {
                    let filteredPreAgencies = allAgencies
                        .filter((d) => {
                            return user.emp_agencies
                                .toString()
                                .split(',')
                                .includes(d.id.toString())
                        })
                        .map((subcat) => {
                            let subCategoryChanged = {}
                            subCategoryChanged.show = subcat.agency_name
                            subCategoryChanged.value = subcat.id
                            return subCategoryChanged
                        })

                    setFilteredAgencies(filteredPreAgencies)
                }
            }
        }
    }, [allAgencies, user])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.filters.action.value = action
        formik.values.page = 1
        formik.values.filters.projects_title.value = ''
        formik.values.filters.users_last_name.value = ''
        formik.values.filters.users_companyname.value = ''
        formik.values.filters.pay_received.value = ''

        // formik.values.filters.custom_projects_manufacturer.value = ''
        // formik.values.filters.custom_projects_model_no.value = ''
        formik.values.filters.projects_date_closed.value = ''
        formik.values.filters.searchterm.value = ''
        if (action === 'all') {
            formik.values.filters.active.type = 'all'
        } else {
            formik.values.filters.active.type =
                action === 'cancel' ? 'in' : 'notin'
            formik.values.filters.active.value = 2
        }

        if (action === 'cancel') {
            formik.values.groupby = ''
        }
        if (pay_status) {
            if (pay_status == 'completed') {
                formik.values.filters.paid_close.value = '1'
            } else {
                formik.values.filters.paid_close.value = '0'
            }
        }
        getAllInvoices(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action, pay_status])

    useEffect(() => {
        if (manage.status === 'refresh') {
            getAllInvoices(formik.values)
        }
    }, [manage])

    useEffect(() => {
        console.log('formikSelection.values', formikSelection.values)
    }, [formikSelection.values])

    const onClickView = (id, sid, type) => {
        // toggleFullScreenPopup(true, type, id, sid)
        handleRedirectInternal(history, `invoice/${type}/all/${id}/${sid}`)
    }

    const onEditNotes = () => {
        toggleInvoiceModal(true)
    }

    const onClickEdit = (id, secondaryID, type) => {
        let selectItem = null
        tableBody.map((item) => {
            if (item.common_invoice === id) {
                selectItem = item
            }
        })
        toggleCreditsPopup(true, type, selectItem)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.project_id = data
        if (
            action === 'paid' ||
            action === 'draft' ||
            action === 'cancel' ||
            action === 'pay_received'
        ) {
            setChangeStatus(true)
        }
    }

    const onClickPreview = (id, type) => {
        window.open(
            `${process.env.REACT_APP_FRONTEND_URL}productView/${id}`,
            '_blank',
            'noopener,noreferrer'
        )
    }

    const getMultipleAction = () => {
        let actionPush = [
            // {
            //     buttonType: 'visibility',
            //     clickType: 'buyer',
            //     onclick: onClickView,
            //     tooltipTitle: 'View Buyer Invoice',
            //     showInMenu: true,
            // },
        ]

        // if (user && user.emp_type !== 'auction_clerk') {
        //     actionPush.push({
        //         buttonType: 'visibility',
        //         clickType: 'seller',
        //         onclick: onClickView,
        //         tooltipTitle: 'View Seller Invoice',
        //         showInMenu: true,
        //     })
        // }

        // if (user?.emp_type !== 'agency' && user?.emp_type !== 'auction_clerk') {
        //     actionPush.push({
        //         buttonType: 'description',
        //         clickType: 'view',
        //         onclick: onEditNotes,
        //         tooltipTitle: 'Add Invoice Notes',
        //         showInMenu: true,
        //     })
        // }

        // if (action === 'unpaid' || action === 'draft') {
        //     actionPush.push({
        //         buttonType: 'monetization_on',
        //         clickType: 'edit',
        //         onclick: onClickEdit,
        //         tooltipTitle: 'Make payment',
        //         showInMenu: false,
        //     })
        // }
        // if (action === 'paid') {
        //     actionPush.push({
        //         buttonType: 'undo',
        //         clickType: 'edit',
        //         onclick: onClickRefundInvoice,
        //         tooltipTitle: 'Refund Invoice',
        //         clickID: 'common_invoice',
        //         secondaryClickID: 'user_id',
        //         showInMenu: true,
        //     })
        // }
        return actionPush
    }

    const onClickRefundInvoice = (id, secondaryID) => {
        toggleRefundPopup(true, 'view', {
            id,
            user_id: secondaryID,
            projects_shipping: 'shipEngine',
        })
    }

    const onClickViewUser = (id, type) => {
        handleRedirectInternal(history, `users/view/${id}`)
    }

    const tableValues = [
        {
            field: 'projects_id',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Lot #',
            filterable: true,
            filterField: 'p.id',
        },
        {
            field: 'user_id',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Bidder #',
            filterable: true,
            filterField: 'u.id',
        },
        {
            field: 'users_first_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User First Name',
            filterable: true,
            filterField: 'u.first_name',
        },
        {
            field: 'users_last_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User Last Name',
            filterable: true,
            filterField: 'u.last_name',
        },

        {
            field: 'common_invoice',
            type: 'hyperlink',
            clickID: 'common_invoice',
            secondaryClickID: 'user_id',
            onclick: onClickView,
            clickType: 'view',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice #',
            filterable: true,
            filterField: 'b.common_invoice',
        },
        {
            field: 'invoice_status',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'projects_date_closed',
            type: 'date',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Order Date',
            filterable: true,
            filterField: 'p.date_closed',
        },
    ]

    if (action === 'paid') {
        tableValues.push({
            field: 'total_invoice',
            type: 'price',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Amount',
            summary: true,
            summaryType: 'addition',
            summaryField: 'b.total_invoice',
        })
    } else {
        tableValues.push({
            field: 'total_amount',
            type: 'price',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Amount',
            summary: true,
            summaryType: 'addition',
            summaryField: 'b.total_amount',
        })
    }

    tableValues.push(
        {
            field: 'projects_title',
            type: 'hyperlink',
            clickID: 'projects_id',
            onclick: onClickPreview,
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Inventory Title',
            filterable: true,
            filterField: 'p.title',
        },
        {
            field: 'custom_projects_manufacturer',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Manufacturer',
            filterable: true,
            filterField: 'it.manufacturer',
        },

        {
            field: 'custom_projects_model_no',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Model No.',
            filterable: true,
            filterField: 'it.model_no',
        },
        {
            field: 'custom_projects_year',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Year',
            filterable: true,
            filterField: 'it.year',
        }
    )

    if (action === 'unpaid') {
        tableValues.push({
            field: 'pay_received',
            type: 'statusIcon',
            tooltipTitle: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Payment Received',
            filterField: 'b.pay_received',
        })
    }

    if (action === 'unpaid') {
        tableValues.push({
            field: 'order_due_date',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Order Due Date',
            filterable: true,
            filterField: 'b.order_due_date',
        })
    }

    if (action === 'draft') {
        tableValues.push({
            field: 'paid_amount',
            type: 'price',
            firstChild: false,
            disablePadding: false,
            label: 'Paid Amount',
            filterable: true,
            filterField: 'b.paid_amount',
        })
    }

    tableValues.push(
        {
            field: 'users_email',
            type: '',
            sort: true,
            type: 'hyperlink',
            clickID: 'user_id',
            onclick: onClickViewUser,
            firstChild: false,
            disablePadding: false,
            label: 'User Email',
            filterable: true,
            filterField: 'u.email',
        },

        {
            field: 'users_companyname',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User Company',
            filterable: true,
            filterField: 'u.companyname',
        },

        //date_added
        {
            field: 'date_added',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Created Date',
            filterable: true,
            filterField: 'b.date_added',
        }
    )

    if (action === 'cancel') {
        tableValues.push({
            field: 'returned_date',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Cancel Date',
        })
        tableValues.push({
            field: 'emp_name',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Employee name',
        })
    }

    if (action === 'paid') {
        tableValues.push({
            field: 'paid_date',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Paid Date',
        })
    }

    // tableValues.push({
    //     field: 'action',
    //     type: 'button',
    //     clickID: 'common_invoice',
    //     secondaryClickID: 'user_id',
    //     sort: false,
    //     firstChild: false,
    //     disablePadding: false,
    //     label: 'Action',
    //     isMultiple: getMultipleAction(),
    // })

    const tableActions = []

    // if (action === 'paid') {
    //     tableActions.push({
    //         label: 'Move to Unpaid',
    //         icon: <span className="material-icons">low_priority</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'draft',
    //     })
    // } else if (action === 'unpaid' || action === 'draft') {
    //     // tableActions.push({
    //     //     label: 'Payment Received',
    //     //     icon: <span className="material-icons">low_priority</span>,
    //     //     onclick: onSelectMultiProducts,
    //     //     type: 'paid',
    //     // })

    //     tableActions.push({
    //         label: 'Mark as Payment Received',
    //         icon: <span className="material-icons">price_check</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'pay_received',
    //     })
    //     tableActions.push({
    //         label: 'Cancel Invoice',
    //         icon: <span className="material-icons">block</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'cancel',
    //     })
    // } else {
    //     tableActions.push(
    //         {
    //             label: 'Move to Unpaid',
    //             icon: <span className="material-icons">low_priority</span>,
    //             onclick: onSelectMultiProducts,
    //             type: 'draft',
    //         },
    //         {
    //             label: 'Move to Paid',
    //             icon: <span className="material-icons">low_priority</span>,
    //             onclick: onSelectMultiProducts,
    //             type: 'paid',
    //         }
    //     )
    // }

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            include_return: true,
            groupby: ' group by b.common_invoice ',
            agency: user?.emp_type == 'agency' ? true : false,
            filters: {
                action: {
                    value: action ? action.toString() : null,
                    type: 'in',
                    field: 'b.paid',
                },
                user_id: {
                    value: props.userId,
                    type: 'in',
                    field: 'b.user_id',
                },
                active: {
                    value: 2,
                    type: 'in',
                    field: 'b.active',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'b.common_invoice',
                },
                projects_title: {
                    value: '',
                    type: 'like',
                    field: 'p.title',
                },
                users_last_name: {
                    value: '',
                    type: 'like',
                    field: 'u.last_name',
                },
                users_companyname: {
                    value: '',
                    type: 'like',
                    field: 'u.companyname',
                },
                pay_received: {
                    value: '',
                    type: 'in',
                    field: 'b.pay_received',
                },
                paid_close: {
                    value: '',
                    type: 'in',
                    field: 'b.paid_close',
                },
                // custom_projects_model_no: {
                //     value: '',
                //     type: 'like',
                //     field: 'it.model_no',
                // },
                // custom_projects_manufacturer: {
                //     value: '',
                //     type: 'like',
                //     field: 'it.manufacturer',
                // },
                projects_date_closed: {
                    value: '',
                    type: 'like',
                    field: 'p.date_closed',
                },
                order_due_date: {
                    value: '',
                    type: 'like',
                    field: 'b.order_due_date',
                },
                agency_id: {
                    value:
                        user?.emp_type == 'agency'
                            ? user?.emp_agencies?.split(',')[0]
                            : '',
                    type: 'in',
                    field: 'p.agency_id',
                },
            },
            summaryFields: getSummaryFields(tableValues),
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllInvoices(values)
        },
    })

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            // {
            //     label: 'Title',
            //     placeholder: 'Enter title',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'projects_title',
            //     filter: true,
            // },
            {
                label: 'User Last Name',
                placeholder: 'Enter User Last Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'users_last_name',
                filter: true,
            },
            {
                label: 'User Company Name',
                placeholder: 'Enter User Company Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'users_companyname',
                filter: true,
            },
            {
                label: 'Payment Status',
                placeholder: 'Select Payment Status',
                class: `${action === 'unpaid' ? '' : 'd-none'} col-sm-4 col-12`,
                type: 'select',
                name: 'pay_received',
                options: [
                    { value: 1, show: 'Received' },
                    { value: '0', show: 'Not Received' },
                ],
                native: true,
                filter: true,
            },
            // {
            //     label: 'Payment Collected',
            //     placeholder: 'Select Payment Status',
            //     class: `${action === 'paid' ? '' : 'd-none'} col-sm-4 col-12`,
            //     type: 'select',
            //     name: 'paid_close',
            //     options: [
            //         { value: ' ', show: 'Any' },
            //         { value: '1', show: 'Yes' },
            //         { value: '0', show: 'No' },
            //     ],
            //     filter: true,
            // },
            // {
            //     label: 'Manufacturer',
            //     placeholder: 'Enter Manufacturer',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'custom_projects_manufacturer',
            //     filter: true,
            // },
            // {
            //     label: 'Model No',
            //     placeholder: 'Enter Model No',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'custom_projects_model_no',
            //     filter: true,
            // },
            {
                label: 'Status',
                placeholder: 'Select Status',
                class: `${action === 'all' ? '' : 'd-none'} col-sm-4 col-12`,
                type: 'select',
                options: [
                    {
                        show: 'Paid',
                        value: 'paid',
                    },
                    {
                        show: 'Unpaid',
                        value: 'unpaid',
                    },
                    {
                        show: 'Partially Paid',
                        value: 'draft',
                    },
                    {
                        show: 'Archive',
                        value: 'cancel',
                    },
                ],
                name: 'action',
                filter: true,
            },
            {
                label: 'Agency',
                type: 'autocomplete',
                placeholder: 'Select Agency',
                class: `col-sm-auto col-12 ${
                    user?.emp_type && user.emp_type === 'agency' ? '' : 'd-none'
                }`,
                name: 'agency_id',
                filter: true,
                size: 'small',
                options: filteredAgencies,
            },
        ],
    }

    const reasonForCancelInvoice = [
        {
            label: 'Reason *',
            name: 'notes',
            type: 'text',
            placeholder: 'Reason for cancellation',
            formik: formikSelection,
        },
    ]

    const invoiceNotes = [
        {
            label: 'Notes',
            name: 'invoice_notes',
            type: 'textarea',
            placeholder: 'Enter your invoice notes',
            formik: formikNotesSelection,
        },
    ]

    useEffect(() => {
        if (responseStatusInvoice) {
            if (
                responseStatusInvoice.status === 'success' &&
                responseStatusInvoice.from === 'productchange'
            ) {
                setChangeStatus(false)
                // setAlert(
                //     responseStatusInvoice.message,
                //     responseStatusInvoice.status
                // )
                getAllInvoices(formik.values)
            }
            clearResponseInvoice()
        }
    }, [responseStatusInvoice])

    useEffect(() => {
        if (responseStatusCart) {
            if (responseStatusCart.status === 'success') {
                if (responseStatusCart.from === 'payCartWallet') {
                    toggleCreditsPopup(false)
                    getAllInvoices(formik.values)
                } else if (responseStatusCart.from === 'payCartOffline') {
                    toggleCreditsPopup(false)
                    getAllInvoices(formik.values)
                }
            }
        }
    }, [responseStatusCart])
    return (
        <>
            <div>
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                {user?.emp_type === 'super_admin' ||
                user?.emp_type === 'admin' ? (
                    <div className="d-flex justify-content-end">
                        <Button
                            id="invoice_report"
                            variant="outlined"
                            className="exportAllBtn"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    fields: [
                                        {
                                            name: 'Invoice ID',
                                            field: 'common_invoice',
                                            type: '',
                                        },
                                        {
                                            name: 'Purchased Qty',
                                            field: 'sold_qty',
                                            type: '',
                                        },
                                        {
                                            name: 'Amount',
                                            field: 'total_amount',
                                            type: 'price',
                                        },
                                        {
                                            name: 'Sold Price',
                                            field: 'buynowamount',
                                            type: 'price',
                                        },
                                        {
                                            name: 'Total Amount',
                                            field: 'total_invoice',
                                            type: 'price',
                                        },
                                        {
                                            name: 'Sold Date',
                                            field: 'date_added',
                                            type: 'date',
                                        },
                                        {
                                            name: 'Paid Date',
                                            field: 'paid_date',
                                            type: 'date',
                                        },
                                        {
                                            name: 'Buyer Email',
                                            field: 'winnerEmail',
                                            type: 'capitalize',
                                        },
                                        {
                                            name: 'Buyer Company',
                                            field: 'winnerCompany',
                                            type: 'capitalize',
                                        },
                                    ],
                                    filters: {
                                        userId: {
                                            type: 'in',
                                            value: props.userId
                                                ? props.userId
                                                : '',
                                            field: 'b.user_id',
                                        },
                                    },
                                    report: `all_invoice_management`,
                                    custom_groupby: 'group by b.id',
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>
                            Export All Data
                        </Button>
                    </div>
                ) : null}
                <CustomTable
                    formik={formik.values}
                    columnVisibilityModel={{
                        id: false,
                        projects_title: false,
                        custom_projects_manufacturer: false,
                        custom_projects_model_no: false,
                        custom_projects_year: false,
                        order_due_date: false,
                        paid_amount: false,
                        users_email: false,
                        paid_date: false,
                        emp_name: false,
                        returned_date: false,
                        date_added: false,
                        users_companyname: false,
                    }}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_invoices}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllInvoices}
                    columnStorageVariable={'table_invoice_index'}
                />
            </div>
            {/* <InvoiceView
                data={manage}
                action={action}
                function={toggleFullScreenPopup}
            /> */}
            <PaymentManage data={manageCredits} function={toggleCreditsPopup} />
            <RefundInvoice data={manageRefund} function={toggleRefundPopup} />
            <CustomDialog
                title={'Change invoice status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                {formikSelection.values.action === 'cancel' &&
                    mapData(reasonForCancelInvoice)}
                <div className="actionWrapper">
                    <Button
                        id="invoice_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="invoice_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>

            <CustomDialog
                title="Invoice notes"
                open={invoiceNotesStatus}
                className="invoiceNotes"
                function={toggleInvoiceModal}
            >
                <h5>Add any specific information related to invoices here.</h5>
                {mapData(invoiceNotes)}
                <div className="actionWrapper">
                    <Button onClick={() => toggleInvoiceModal()}>Cancel</Button>
                    <form
                        onSubmit={formikNotesSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton type="submit" label="Confirm" />
                    </form>
                </div>
            </CustomDialog>
        </>
    )
}

export default UserInvoices
